import PolicyViewer from '../PolicyViewer'

const TermsAndConditionsText = () => {
  return <PolicyViewer fieldKey="termsAndConditions" />
}

export default TermsAndConditionsText
